export default __webpack_public_path__ + "static/media/vehicle.61415832.svg";